var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pentagon",class:[_vm.level]},[_vm._v(" Ready for "+_vm._s(_vm.level)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }